import type { EntityStatus } from '@ms/yammer-data-support';
import { getStatus } from '@ms/yammer-data-support';

import type { FeatureAccessInsights, YammerState } from '../../state/types';

type GetFeatureAccessInsights = (state: YammerState) => FeatureAccessInsights | undefined;
/**
 * @deprecated PERFORMANCE This returns an entity object which will force re-renders if any API call causes it
 * to be updated. This should be replaced with a `getFeatureAccessInsightsField` selector.
 */
export const getFeatureAccessInsights: GetFeatureAccessInsights = (state: YammerState) =>
  state.featureAccessInsights.fulfilled;

type GetFeatureAccessInsightsStatus = (state: YammerState) => EntityStatus;
export const getFeatureAccessInsightsStatus: GetFeatureAccessInsightsStatus = (state) =>
  getStatus(state.featureAccessInsights);
